var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { canQueryData } from "../CanQueryData";
import { STR_ERRORS } from "../../../Common";
export function executeSend(r) {
    if (canQueryData()) {
        return executeRequest(r.request)
            .then(response => {
            r.resolve(response);
        }).catch(error => {
            r.reject(error);
        });
    }
    const retryBackOff = r.retryAttempt + 1;
    if (r.retryAttempt >= r.maxRetryAttempts) {
        return r.reject(STR_ERRORS.MaxNumberOfRetriesExceeded);
    }
    r.retryAttempt = r.retryAttempt + 1;
    setTimeout(() => executeSend(r), r.retryInterval * retryBackOff);
}
function executeRequest(r) {
    return __awaiter(this, void 0, void 0, function* () {
        const response = yield fetch(r.requestFormatter(r.message));
        return yield r.responseFormatter(response);
    });
}
//# sourceMappingURL=ExecuteSend.js.map